import { TwitterTimelineEmbed } from 'react-twitter-embed';
function XTimeline() {
    return (
        <div className='w-100'>
            <TwitterTimelineEmbed
                sourceType="profile"
                screenName="costacrociere"
                options={{ height: 600 }}
            />
        </div>
    );
}
export default XTimeline;
